import { render } from "./Sectores.vue?vue&type=template&id=689a80cb&scoped=true"
import script from "./Sectores.vue?vue&type=script&lang=js"
export * from "./Sectores.vue?vue&type=script&lang=js"

import "./Sectores.vue?vue&type=style&index=0&id=689a80cb&scoped=true&lang=scss"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689a80cb"]])

export default __exports__